
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateFlowModalComponent } from './create-flow-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatInputModule,
        ReactiveFormsModule,
    ],
    declarations: [CreateFlowModalComponent],
    exports: [CreateFlowModalComponent],
})
export class CreateFlowModalModule {}
